import React from 'react'
import header from '../public/Pictures/MSRheader.jpg'
import PicCont from './PicCont';
import LinkWrap from './LinkWrap';


const PageHeader = ({children, breadcrumbs}) => {

  return <div data-msr-surface='dark' className='pageHeader'>
     <PicCont priority background src={header} />
     <div className="back"></div>
     <div className="textBox">
     {breadcrumbs?.length && <div className="breadCrumb">
     <LinkWrap noPrefetch href={'/'} >Home &gt;</LinkWrap>
        {breadcrumbs.map((b,i) =>   <LinkWrap key={i} noPrefetch href={b[1]} >{b[0]}{i === breadcrumbs.length -1 ? '' : ` >`} </LinkWrap>)}

          </div>}
          {children}
     </div>
  </div>
}

export default PageHeader
